export default __webpack_public_path__ + "static/msc-a2a425ab0927a4f07d03ae931418e8eb.svg";